import { useAuth } from '../../Providers/AuthProvider'
import useGetProductPrices from '../BasketPage/Hooks/useGetProductPrices'
import { ConvertPriceToString } from '../../Helpers/CustomConverter'
import NewPromoSellOutOldPrice from './NewPromoSellOut/NewPromoSellOutOldPrice'
import { useParams } from '../../Providers/ParamsProvider'

/**
 * DK : Komponent wyświetlający cene
 * @param {boolean} isProductDetails Czy jest to wejście z detali produktu (inne pozycjonowanie)
 * @returns 
 */
const ProductThreshold = ({ product, isProductDetails }) => {
    const { wholesalePrices, authState } = useAuth()
    const { priceNet } = useGetProductPrices(product)
    const { isMobile } = useParams()

    const calculatePrice = (threshold) => {
        let discountValue = (parseFloat(priceNet) * threshold.discount / 100)
        return parseFloat(priceNet) - discountValue
    }

    const getAlignItemsStyle = () => {
        if (isMobile) {
            return 'align-items-start'
        }
        else {
            return isProductDetails ? 'align-items-start' : 'align-items-center'
        }
    }

    const baseUnit = product && product.baseUnit ? product.baseUnit.toLowerCase() : product.baseUnit
    const alignItemsStyle = getAlignItemsStyle()
    const fontSize = isMobile ? '12px' : '16px'
    const fontSizeForThreshold = isMobile ? '12px' : '16px'

    if (product.priceThresholds && product.priceThresholds.length > 0 && priceNet !== 0) {
        if ((!wholesalePrices && product.priceThresholds[0].custId === '-1') || (wholesalePrices && (product.priceThresholds[0].custId === '-1' || product.priceThresholds[0].custId === authState.custId))) {
            return (
                <div className={`d-flex flex-column ${alignItemsStyle}`}>
                    <span className='light-text-color' style={{ fontSize: fontSizeForThreshold }}>{`Cena netto ${isMobile ? '' : 'od ilości'}`}</span>
                    <span>
                        <NewPromoSellOutOldPrice
                            product={product}
                            isThreshold={true}
                            fontSize={fontSizeForThreshold}
                        />
                    </span>
                    <div className='d-flex'>
                        <div className='d-flex flex-column'>
                            <span style={{ fontSize: fontSizeForThreshold }}>1 +</span>
                            {product.priceThresholds.map((t, index) => (
                                <span style={{ fontSize: fontSizeForThreshold }} key={index}>{t.thresholdValue} +</span>
                            ))}
                        </div>
                        <div className='d-flex flex-column'>
                            <b className={`ms-2`} style={{ fontSize: fontSizeForThreshold }}>{ConvertPriceToString(priceNet, product.currency)}/{baseUnit}</b>
                            {product.priceThresholds.map((t, index) => (
                                <span className={`ms-2`} style={{ fontSize: fontSizeForThreshold }} key={index}>{ConvertPriceToString(calculatePrice(t), product.currency)}/{baseUnit}</span>
                            ))}
                        </div>
                    </div>
                </div>
            )
        }
    }
    return (
        <div className="row">
            <div className={`d-flex flex-column justify-content-start ${alignItemsStyle}`}>
                <span className='light-text-color' style={{ fontSize: fontSize }}>Cena netto</span>
                <span>
                    <NewPromoSellOutOldPrice
                        product={product}
                        isThreshold={true}
                        fontSize={fontSize}
                    />
                </span>
                <b style={{ fontSize: fontSize }}>{ConvertPriceToString(priceNet, product.currency)}/{baseUnit}</b>
            </div>
        </div>
    )
}

export default ProductThreshold